import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { BroadcastListPage } from '@/features/marketing'

export const Route = createFileRoute('/_authenticated/marketing/broadcast/')({
  component: () => (
    <RequirePermission permission='marketing.read'>
      <BroadcastListPage />
    </RequirePermission>
  ),
})
